







import Vue from 'vue';
import TheLoadingOverlay from '@/components/generic/TheLoadingOverlay.vue';

export default Vue.extend({
  name: 'App',

  components: {
    TheLoadingOverlay,
  },
});
